import { Component, OnInit } from '@angular/core';
import { IconService } from '@app/icon.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  
  constructor(private iconService:IconService){
    iconService.initializeIcons()
  }
  ngOnInit(): void {
    console.info('==========================================================');
    console.info(
      `Running version ${environment.version} on ${environment.name} environment`
    );
    console.info('==========================================================');
  }
}
